import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import dropdown from "./ic-dropdown.svg";

import {
  DropdownContainer,
  DropdownLabel,
  SelectedOption,
  DropdownOptionsList,
  DropdownOptionsListItem,
  RequiredMessage,
  DisplayLabel,
  DisplaySubLabel,
} from "./Dropdown.styled";
import "../../AddEditSolution.scss";

const Dropdown = (props) => {
  const {
    label,
    name,
    value,
    required,
    error,
    defaultOption,
    disabled,
    containerStyles,
    labelStyles,
    inputStyles,
    errorStyles,
    options,
    onChange,
  } = props;

  const [isOpen, setOpenStatus] = useState(false);
  const [selectedOption, setSelectedOption] = useState();

  const toggleDropdown = () => {
    if (!disabled) {
      setOpenStatus(!isOpen);
    }
  };

  const closeDropdown = () => {
    setOpenStatus(false);
  };

  const onOptionClick = (o) => {
    setSelectedOption(o.label);
    setOpenStatus(false);
    onChange(o);
  };

  useEffect(() => {
    if (options && options.length > 0) {
      const selectedOptionLocal = options.find(
        (option) => option.value === value
      );
      if (selectedOptionLocal) {
        setSelectedOption(selectedOptionLocal.label);
      }
    }
    if (value === "") setSelectedOption("");
  }, [value, options]);

  return (
    <DropdownContainer disabled={disabled} containerStyles={containerStyles}>
      <DropdownLabel
        labelStyles={labelStyles}
        disabled={disabled}
        required={required}
      >
        {label}
      </DropdownLabel>
      <SelectedOption
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        inputStyles={inputStyles}
        disabled={disabled}
        onClick={toggleDropdown}
      >
        <span>{selectedOption || defaultOption}</span>
        <Image
          src={dropdown}
          alt="Dropdown icon"
          className={`${
            isOpen
              ? "open addd-edit-solution__dropdown-image-icon"
              : "addd-edit-solution__dropdown-image-icon"
          }`}
        />
      </SelectedOption>
      {isOpen && (
        <DropdownOptionsList>
          {options &&
            options.length > 0 &&
            options.map((o) => (
              <DropdownOptionsListItem
                key={o.label + o.value}
                value={o.value}
                onClick={() => onOptionClick(o)}
              >
                <DisplayLabel>{o.displayLabel}</DisplayLabel>
                <DisplaySubLabel>{o.displaySubLabel}</DisplaySubLabel>
              </DropdownOptionsListItem>
            ))}
        </DropdownOptionsList>
      )}
      {error && (
        <RequiredMessage errorStyles={errorStyles}>{error}</RequiredMessage>
      )}
    </DropdownContainer>
  );
};

Dropdown.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  defaultOption: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  containerStyles: PropTypes.shape({}),
  labelStyles: PropTypes.shape({}),
  inputStyles: PropTypes.shape({}),
  errorStyles: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};

Dropdown.defaultProps = {
  label: "",
  value: "",
  disabled: false,
  required: false,
  error: "",
  containerStyles: null,
  labelStyles: null,
  inputStyles: null,
  errorStyles: null,
};

export { Dropdown };
